export const ACCOUNT_NAME_MIN_LENGTH = 3;
export const ACCOUNT_NOTE_MAX_LENGTH = 255;
